import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ModalService } from '../../../shared/services/modal.service';
import { Router } from '@angular/router';
import { SettingsService } from '../../../core/http/settings.service';
import { AuthServiceService } from '../../../core/http/auth-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Output() public sidenavToggle = new EventEmitter();

  token: string;
  isLoading = true;
  Errors = null;
  data = null;
  run = false;
  name;
  username: string;
  role = localStorage.getItem('role');
  toggle = false;

  constructor(
    public router: Router,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService
  ) {}

  ngOnInit(): void {
    if (
      this.role == 'self-service user' ||
      this.role == 'self-service consultant'
    ) {
      console.log('online');

      this.setting.getTitleonline().subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          switch (this.data.message) {
            case 'Session Expired':
              this.data.message = 'false';
              // window.location.href = "/login";
              this.router.navigate(['/login']);
              break;
            case 'false':
              break;
            default:
            // code block
          }
          // this.data = resSuccess
          // if ( this.data.message = "Session Expired") {
          //   if (this.run = false){
          //     window.location.href = "/login";
          //     this.run = true
          //   }
          // }
        },
        (resErr) => {
          this.Errors = resErr;
        }
      );
    } else {
      console.log('offline');

      this.setting.getTitle().subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          switch (this.data.message) {
            case 'Session Expired':
              this.data.message = 'false';
              // window.location.href = "/login";
              this.router.navigate(['/login']);
              break;
            case 'false':
              break;
            default:
            // code block
          }
          // this.data = resSuccess
          // if ( this.data.message = "Session Expired") {
          //   if (this.run = false){
          //     window.location.href = "/login";
          //     this.run = true
          //   }
          // }
        },
        (resErr) => {
          this.Errors = resErr;
        }
      );
    }
    this.getToken();
    console.log(this.role);

    this.name = localStorage.getItem('name');
  }

  getToken() {
    this.token = localStorage.getItem('token');
    this.username = localStorage.getItem('username');
  }
  public onToggleSidenav() {
    this.sidenavToggle.emit();
  }
}
